import React, {Fragment, useEffect, useState} from 'react'
import {useGlobalFilter, useRowSelect, useSortBy, useTable} from 'react-table'
import ListLoader from '../loaders/ListLoader'
import IndeterminateCheckbox from '../IndeterminateCheckbox'
import TableEmptyListMessage from '../TableEmptyListMessage'
import ListPagination from '../ListPagination'
import SearchInput from '../SearchInput'
import './ListTable.css'
import Button from '@material-ui/core/Button'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import Popover from '@material-ui/core/Popover'
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Scroll from 'react-scroll';
import {NavLink} from 'react-router-dom';
import ErrorIcon from '@material-ui/icons/Error'
import {Controller, useForm} from 'react-hook-form'
import TextField from '@material-ui/core/TextField'
import {useMutation, useQueryClient} from 'react-query'
import {storeLead} from '../../api'
import {useTranslation} from 'react-i18next';
import AlertToastr from '../../Utils/alert'
import profileTabIcon from '../../assets/img-new/profileTabIcon.svg';
import tabSecurityIcon from '../../assets/img-new/tabSecurityIcon.svg';
import eye from '../../assets/img-new/eye.svg';

const pluralize = require('pluralize')


const ListTable = props => {
    const {
        columns,
        data,
        loading,
        isSelectionColumn,
        onSelectedRows,
        onRowClick,
        onSort,
        emptyDataText,
        pagination,
        pageLimit,
        onPageChange,
        onLimitChange,
        onSearch,
        onHideColumns,
        recordsInfo,
        disableSearchBlock = false,
        disablePagination = false,
        disableTopBorder = false,
        hiddenColumnsStorageKey = null,
        initSort,
        showQuickInsertForm,
        quickInsertFormData = {},
        onQuickInsertFormSuccess,
        showTabs,
        tabsValue,
        renderHeader,
        hideIdColumn,
        renderSegmentFilter
    } = props

    const {
        control,
        getValues,
        reset,
    } = useForm({
        mode: 'onTouched',
    })
    const queryClient = useQueryClient()

    const [anchorImportEl, setAnchorImportEl] = useState(null)
    const [valueTabs, setValueTabs] = useState(tabsValue);
    const isColumnPopoverOpen = Boolean(anchorImportEl)

    const storeLeadMutation = useMutation(storeLead)
    const { t } = useTranslation();
    const tableInstance = useTable({
            columns,
            data,
            manualSortBy: true,
            manualGlobalFilter: true,
            initialState: {
                sortBy: initSort ? initSort : [],
                hiddenColumns: JSON.parse(localStorage.getItem(hiddenColumnsStorageKey)) || []
            }
        },

        useGlobalFilter,
        useSortBy,
        useRowSelect,
        hooks => {
            hooks.visibleColumns.push((columns) => {
                return isSelectionColumn ? [
                    {
                        id: 'selection',
                        Header: ({getToggleAllRowsSelectedProps}) => (
                            <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
                        ),
                        Cell: ({row}) => (
                            <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
                        ),
                        className: 'tableId'
                    },
                    ...columns
                ] : columns
            })
        }
    )


    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        selectedFlatRows,
        state: { sortBy, globalFilter, hiddenColumns },
        setGlobalFilter,
        allColumns,
        visibleColumns,
        toggleHideAllColumns,
    } = tableInstance

    useEffect(() => {
        if (hiddenColumnsStorageKey) {
            localStorage.setItem(hiddenColumnsStorageKey, JSON.stringify(hiddenColumns))
        }
    }, [hiddenColumns, hiddenColumnsStorageKey])
    useEffect(() => {
        if (hideIdColumn && hiddenColumnsStorageKey) {
            localStorage.setItem(hiddenColumnsStorageKey, JSON.stringify([...hiddenColumns,'id']))
        }
    }, [])

    useEffect(() => {
        if (onHideColumns) {
            onHideColumns(visibleColumns.filter(item => item.id !== 'selection').map(item => item.id))
        }
    }, [visibleColumns, onHideColumns])

    useEffect(() => {
        if (onSearch)
            onSearch(globalFilter)
    }, [globalFilter, onSearch])

    useEffect(() => {
        if (onSelectedRows)
            onSelectedRows(selectedFlatRows.map(row => row.original.id))
    }, [selectedFlatRows, onSelectedRows])

    useEffect(() => {
        return onSort(sortBy.map(item => (
            {
                key: item.id,
                direction: item.desc ? 'desc' : 'asc'
            }
        )))
    }, [sortBy, onSort])
    const handleChangeTabs = (event, newValue) => {
        setValueTabs(newValue);
    };
    const renderSearchBlock = () => {
        if (!onSearch) return null

        return (
            <div className="searchHolder">
                <div className="inputHolder mr10">
                    <SearchInput
                        search={globalFilter}
                        onChange={setGlobalFilter}
                    />
                </div>
                {renderColumnsSelector()}
            </div>
        )
    }

    const renderEmptyList = () => {
        if (!pagination || pagination['total'] > 0) return null
        return <TableEmptyListMessage>{emptyDataText}</TableEmptyListMessage>
    }

    const renderPagination = () => {
        if (!pagination) return null
        if (disablePagination) return null

        if (pagination && pagination['total'] > 0) {
            return (
                <ListPagination
                    limit={pageLimit}
                    pagination={pagination}
                    onChange={p => {
                        Scroll.animateScroll.scrollToTop()
                        onPageChange(p)
                    }}
                    onLimitChange={onLimitChange}
                />
            )
        }
        return null
    }

    const renderColumnsSelector = () => {
        return (
            <Fragment>
                <Button
                    startIcon={hiddenColumns.length ? <ErrorIcon color='disabled' /> : null}
                    endIcon={<ArrowDropDownIcon />}
                    onClick={(e) => setAnchorImportEl(e.currentTarget)}
                    color={hiddenColumns.length ? 'primary' : 'default'}
                >
                    <div className="title columnsButtonWrapper"> <img src={eye} style={{height: '15px'}} alt=" " /> Hide Columns</div>
                </Button>
                <Popover
                    open={isColumnPopoverOpen}
                    anchorEl={anchorImportEl}
                    onClose={() => setAnchorImportEl(null)}
                    className='importPopover'
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                >
                    <div className="importPopoverContent">
                        <div className="ipTitleWrapper">
                            <div className="title">{t("Sources.Columns")}</div>
                            <div onClick={() => toggleHideAllColumns(false)}
                                 style={{opacity: hiddenColumns.length ? 1 : 0.3}}
                                 className={hiddenColumns.length ? 'linkColorNormal title clickable' : 'title'}>
                                {t("Sources.Reset")}
                            </div>
                        </div>
                        <div className="fileProgressHolder">
                            {
                                allColumns
                                    .filter(column => {
                                        return column.id !== 'selection' && column.id !== 'actions'
                                    })
                                    .map(column => {

                                        const isDisabled = column.Header === 'Phone' || column.Header === 'Email'
                                        return (
                                            <div key={column.id}>
                                                <label>
                                                    <div className="checkboxWrapper">
                                                        <IndeterminateCheckbox isColumn={true} disabled={isDisabled} {...column.getToggleHiddenProps()}/>
                                                         <span style={{fontSize: '14px'}}>{column.Header}</span>
                                                    </div>
                                                    {/* <Checkbox
                                                        {...column.getToggleHiddenProps()}
                                                        disabled={isDisabled}
                                                        color="primary"
                                                    />
                                                    <span style={{fontSize: '14px'}}>{column.Header}</span>  */}
                                                </label>
                                            </div>
                                        )
                                    })
                            }
                        </div>
                    </div>
                </Popover>
            </Fragment>
        )
    }

    const renderFieldInput = (id, placeholder) => {
        if (id === 'selection') return null

        const disabled = !parseInt(id) || storeLeadMutation.isLoading

        return (
            <Controller
                key={id}
                name={id}
                control={control}
                defaultValue=""
                render={({onChange, value}) => {
                    return (
                        <TextField
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') submitQuickForm()
                            }}
                            disabled={disabled}
                            size="small"
                            style={{minWidth: '150px'}}
                            placeholder={placeholder}
                            onChange={onChange}
                            value={value}
                            variant="outlined"
                            margin="normal"
                        />
                    )
                }}
            />
        )
    }

    const submitQuickForm = async () => {
        const data = getValues()

        delete data['id']
        delete data['updated_at']
        delete data['status']
        delete data['duplicates']

        try {
            const storeData = {
                source_id: quickInsertFormData.source_id,
                list_id: quickInsertFormData.list_id,
                attributes: Object.keys(data).map(attrId => ({attr_id: attrId, value: data[attrId]}))
            }

            await storeLeadMutation.mutateAsync(storeData)
            reset()
            queryClient.invalidateQueries('leadsList').then()
            queryClient.invalidateQueries(['listLeads']).then()
            if (onQuickInsertFormSuccess) onQuickInsertFormSuccess()
        } catch (error) {
            if (error && error.response && error.response.data && error.response.data.errors)
                AlertToastr.showErrorAlert(error.response.data.errors)
        }
    }
    const renderLink = (to, title, description, img, hide = false) => {
        if (hide) return null;
        return (
                <NavLink to={to} className="pnItemContent">
                    <div className="profileItemContent">
                        <div className="profileItemContent profileItemContent_title_description">
                            <div className="profileItemContent profileItemContent_title_description title">{title}</div>
                        </div>
                    </div>
                </NavLink>
        );
    };

    return (
        <div className="pageTableBlock">
            {
                showTabs && (
                    <div className="LeadsTabs">
                        <Tabs value={valueTabs} onChange={handleChangeTabs}>
                            <Tab className="LeadsTabsTab" label={renderLink('/leads', t('New Profile.Leads'), t('New Profile.Change Personal Information'), profileTabIcon)}/>
                            <Tab className="LeadsTabsTab" label={renderLink('/leads/sources', t('New Profile.Sources'), t('New Profile.Change Password'), tabSecurityIcon)}/>
                        </Tabs>
                    </div>
                )
            }
            {renderSegmentFilter && <div className="mb15">{renderSegmentFilter()}</div>}
            <div className="searchWrapper">
                {
                    !disableSearchBlock && (renderSearchBlock())
                }
                <div style={{display: 'flex', alignItems: 'baseline'}}>
                    {renderHeader && renderHeader()}
                    {recordsInfo && !!recordsInfo.length && (
                    <div className="mb15" style={{ marginLeft: '10px'}}>
                        {
                            recordsInfo.map((item, index) => {
                                return (
                                    <span key={index} style={{fontSize: '12px'}}>
                                        <span style={{fontWeight: 'bold'}}>{item.count}</span>&nbsp;
                                        <span style={{opacity: '.5'}}>
                                            {item.notNoun ? item.label : pluralize(item.label, item.count)}
                                            {recordsInfo.length-1 === index ? '' : ','}
                                        </span>&nbsp;
                                    </span>
                                )
                            })
                        }
                    </div>
                )}
                </div>
            </div>
            <div className={`tableHolder hasCheckboxes rowClickable${disableTopBorder ? '' : ' noBorderTop'}`}>
                <div className="tableScrollHolder">
                    <table {...getTableProps()}>
                    <thead>
                    {
                        headerGroups.map(headerGroup => (
                            <tr {...headerGroup.getHeaderGroupProps()}>
                                {
                                    headerGroup.headers.map(column => {
                                        const sortClass = column.isSorted ? (column.isSortedDesc ? 'hasArrow' : 'hasArrow up') : ''
                                        const columnClass = `${column.className} ${sortClass}`
                                        return (
                                            <th {...column.getHeaderProps(column.getSortByToggleProps())}
                                                className={columnClass}
                                            >
                                                {column.render('Header')}
                                            </th>
                                        )
                                    })
                                }
                            </tr>
                        ))
                    }
                    {
                        showQuickInsertForm && headerGroups.map(headerGroup => (
                            <tr {...headerGroup.getHeaderGroupProps()}>


                                {
                                    headerGroup.headers.map(column => {
                                        return (
                                            <th {...column.getHeaderProps()}>
                                                {renderFieldInput(column.id, column['Header'])}
                                            </th>
                                        )
                                    })
                                }

                            </tr>
                        ))
                    }
                    </thead>
                    <tbody {...getTableBodyProps()}>
                    {loading && <ListLoader/>}
                    {renderEmptyList()}
                    {
                        rows.map(row => {
                            prepareRow(row)
                            return (
                                <tr {...row.getRowProps()}>
                                    {
                                        row.cells.map(cell => {
                                            return (
                                                <td {...cell.getCellProps({
                                                    className: cell.column.className
                                                })} onClick={() => {
                                                    if (cell.value !== undefined && onRowClick) {
                                                        onRowClick(cell.row.original)
                                                    }
                                                }}>
                                                    {cell.render('Cell')}
                                                </td>
                                            )
                                        })
                                    }
                                </tr>
                            )
                        })
                    }
                    </tbody>
                </table>
                </div>
                {renderPagination()}
            </div>
        </div>
    )
}

export default ListTable
